<mat-progress-bar *ngIf="isLoading" style="width: 100%; margin-top: 8px" [mode]="'indeterminate'"></mat-progress-bar>
<app-offboarding-requirements
  *ngIf="!isLoading"
  [companies]="company"
  [_roles]="roles"
  (dialogCloseChange)="manageOffboardingRequests($event)"
>
</app-offboarding-requirements>
